import type {
  McpServerPickerActions,
  McpServerPickerState,
} from "../hooks/use-mcp-server-picker";
import type { Mode } from "../types";
import { SearchResults } from "./search-results";
import { SelectedToolsReview } from "./selected-tools-review";
import { ToolsView } from "./tools-view";

/**
 * Routes the picker's scroll body by the active view: a drilled-in server's
 * tools, the selection review, or the search/catalog results. All view data is
 * derived by the hook; this component only picks a renderer and forwards it.
 */
export function PickerBody({
  actions,
  mode,
  scrollContainer,
  state,
}: {
  actions: McpServerPickerActions;
  mode: Mode;
  scrollContainer: HTMLElement | null;
  state: McpServerPickerState;
}) {
  const { view } = state;

  if (view.type === "tools") {
    if (!state.drillInServer) {
      return null;
    }
    return (
      <ToolsView
        onBack={actions.backToServers}
        onToggleTool={actions.toggleTool}
        scrollContainer={scrollContainer}
        selected={state.selected}
        server={state.drillInServer}
        tools={state.drillInTools}
      />
    );
  }

  if (view.type === "review") {
    return (
      <SelectedToolsReview
        groups={state.reviewGroups}
        onBack={actions.backToServers}
        onOpenServer={actions.openTools}
        onToggleTool={actions.toggleTool}
        scrollContainer={scrollContainer}
        selected={state.selected}
      />
    );
  }

  return (
    <SearchResults
      filteredServers={state.filteredServers}
      filteredToolCount={state.filteredToolCount}
      filteredToolGroups={state.filteredToolGroups}
      hasSearch={state.hasSearch}
      mode={mode}
      onOpenServer={actions.openTools}
      onSetSearchScope={actions.setSearchScope}
      onShowUnoptimized={() => actions.setShowUnoptimizedMatches(true)}
      onToggleServer={actions.toggleServer}
      onToggleTool={actions.toggleTool}
      scrollContainer={scrollContainer}
      searchScope={state.searchScope}
      selected={state.selected}
      unoptimizedMatch={state.unoptimizedMatch}
    />
  );
}
